"use strict";
/**
 * Adds SVG element `contains` method for IE11.
 */
if (typeof SVGElement.prototype.contains === 'undefined') {
    SVGElement.prototype.contains = HTMLDivElement.prototype.contains;
}
